
<template>
  <div class="guestPassEdit full-height">
    <ld-header>
      订单信息填写
    </ld-header>
    <div class="guestpasswrapper">
      <mescroll-vue
        ref="mescroll"
        :down="down"
      >
        <div>
          <div class="box">
            <van-field
              label="服务机场"
              input-align="right"
              readonly
            >
              <template #extra>
                {{ params.cityName }} {{ params.serverAirportName }}
              </template>
            </van-field>
            <van-field
              input-align="right"
              label="服务时间"
              v-model="params.serverTime"
              readonly
            />
            <van-field
              label="服务类型"
              input-align="right"
              readonly
            >
              <template #extra>
                {{ params.flightTypeName }} {{ params.serverTypeName }} {{ searchInfo.serviceName }}
              </template>
            </van-field>
            <van-field
              label="航班号"
              input-align="right"
              v-model="params.flightNo"
              readonly
            />
            <van-field
              input-align="right"
              label="基准价"
              readonly
            >
              <template #extra>
                &yen;{{ searchInfo.baseSalesPrice ||0 }}
              </template>
            </van-field>
            <van-field
              input-align="right"
              label="固定价"
              readonly
            >
              <template #extra>
                &yen;{{ searchInfo.salePrice ||0 }}/人
              </template>
            </van-field>
            <van-field
              input-align="right"
              label="服务费"
              readonly
            >
              <template #extra>
                &yen;{{ searchInfo.serviceFee ||0 }}/人
              </template>
            </van-field>
            <van-field
              input-align="right"
              label="人数"
              readonly
            >
              <template #extra>
                <van-stepper
                  v-model="value"
                />
              </template>
            </van-field>
          </div>
          <!--出行人 -->
          <!-- <traver
            title="乘机人"
            cplx="10917"
            :traveler-list="travelerList"
            element=".guestPassEdit"
            class="box"
          /> -->

          <!--  -->
          <trip-type
            is-switch
            :switch-title="tripType==1?'本次预订为因公预订':'本次预订为因私预订'"
            class="box"
          />

          <!-- 差旅信息 -->
          <travel-info
            v-show="tripType==1"
            ref="travelinfo"
            @selected="getTavelInfo"
            element=".guestPassEdit"
            class="box"
          />

          <!-- 联系信息 -->
          <div>
            <van-field
              :label="$t('D022','联系信息')"
              :readonly="true"
              @click="$refs['linker'].toggle()"
            >
              <div slot="input">
                {{ linker.linkMan }} ({{ linker.linkTel || linker.linkMobile }})
                
                <div class="font12 gray">
                  {{ $t('D020','邮箱') }} ({{ linker.linkEmail }})
                </div>
              </div>
            </van-field>
          </div>
          <div class="list">
            &nbsp;
          </div>
        </div>
      </mescroll-vue>
    </div>

    <!--  -->
    <ld-tabbar
      ref="tabbar"
      class="bg-white shadow"
    >
      <van-row
        class="full-width list"
        type="flex"
        align="center"
        gutter="8"
        justify="center"
      >
        <van-col span="16">
          <span class="font22 money-color">&yen;
            <span v-show="searchInfo.pricingModel==1">
              {{ (searchInfo.salePrice+searchInfo.serviceFee) *(value||1) }}
            </span>
            <span v-show="searchInfo.pricingModel==2">
              {{ (searchInfo.baseSalesPrice||0)+ (searchInfo.salePrice+searchInfo.serviceFee)*(value||1) }}
            </span>
          </span>
          <span class="font10 gray">&nbsp; {{ $t('E017','共') }}{{ value }}人</span>
        </van-col>
        <van-col
          span="8"
        >
          <ld-button
            main
            size="md"
            @click="book"
          >
            提交订单
          </ld-button>
        </van-col>
      </van-row>
    </ld-tabbar>

    <!-- 编辑联系人 -->
    <ld-edit-linker
      ref="linker"
      :data="linker"
      @selected="getLinker"
    />
  </div>
</template>

<script>
import {Field,Cell,Stepper} from 'vant'
import { mapGetters } from 'vuex'
import ldEditLinker from 'Components/ldEditLinker'
// import traver from 'Components/tk/traver'
import ldButton from 'Common/ldButton'
import ldTabbar from 'Components/ldTabbar/ldTabbar'
import travelInfo from 'Components/travelInfo'
import MescrollVue from 'mescroll.js/mescroll.vue'
// import { getName, getIdType, getIdNumber } from 'Utils/publicFun'
import tripType from 'Common/tripType'

export default {
  name: 'GuestPassEdit',
  components:{
    [Field.name]: Field,
    [Cell.name]: Cell,
    [Stepper.name]: Stepper,
    ldEditLinker,
    ldTabbar,
    ldButton,
    // traver,
    travelInfo,
    MescrollVue,
    tripType
  },
  data () {
    return {
      down:{use:false},
      linker:{
        linkEmail:'',
        linkMan:'',
        linkTel:''
      },
      value:1
    }
  },
  computed: {
    ...mapGetters({
      tripType:'tripType',
      userInfo:'userInfo',
      travelerList: 'guestPass/travelerList',
      searchInfo: 'guestPass/searchInfo',
      params: 'guestPass/params',
      flightInfo: 'guestPass/flightInfo',
      sysType:'sysType'
    }),
  },
  created () {
    this.linker={
      linkEmail:this.userInfo.empInfo.email,
      linkMan:this.userInfo.empInfo.empName,
      linkTel:this.userInfo.empInfo.phoneNumber
    }
  },
  methods:{
    book(){
      // if(this.travelerList.length==0){
      // 	this.$toast('请选择乘机人！')
      // 	return
      // }
      if(!this.linker.linkTel){
        this.$toast('联系人手机号不能为空！')
        return
      }
      if(this.tripType==1){
        let bl=this.$refs.travelinfo.result()//判断差旅信息是否填写完整 
        if(bl==false){
          return
        }
      }
      // let psgList = this.travelerList.map((item,index) => {
      // 	return {
      // 		psgName: getName(item),
      // 		psgType: item.psgType||'1',
      // 		cardType: getIdType(item),//证件类型
      // 		idNo: getIdNumber(item),//证件号码
      // 		phoneNumber: item.phoneNumber,
      // 		empId: item.conempId || item.empId
      // 	}
      // })
      this.$api['airService/bookOrder']({
        orderType:'11031',
        productId:this.searchInfo.id,
        personTime : this.value,//this.travelerList.length,//人次 
        flightDate:this.params.departDate,
        flightNo :this.params.flightNo,
        deptCity  :this.flightInfo.departAirport,
        deptCityName:this.flightInfo.departCityName,
        arrCity :this.flightInfo.arriveAirport,
        arrCityName :this.flightInfo.arriveCityName,
        // 'psgBeanList': psgList,
        serverTime:this.params.serverTime,
        serverType :this.params.serverType,
        serverAirportCode:this.params.serverAirportCode,
        serverAirportName:this.params.serverAirportName,
        linkman :this.linker.linkMan,
        linkMobile:this.linker.linkTel ,
        linkEmail:this.linker.linkEmail ,
        tripType:this.tripType,
        'travelInfo' :this.travelInfo,
        orderFrom :this.sysType,
        relateOrder :this.params.relateOrder,//关联单号
        serverRemark:this.params.serverRemark,
      }).then(res=>{
        let cache=res.data||{}
        this.$router.push({path:'/guestPass/order',query: { orderId:cache.orderId}})
      })
    },
    getTavelInfo(info) {// 获取差旅信息
      let obj={
        'projectId': '',
        'projectCode': '',
        'projectName': '',
        'ccsqdId': '',
        'ccsqdNo': '',
        'routeId': '',
        'costCenterId': '',
        'costCenterCode': '',
        'costCenterName': '',
        'violateitemCode': '',
        'violateitem': '',
        'reasonCode': '',
        'reasonDesc': '',
        'corpId': '',
        'corpCode': '',
        'corpName': '',
        'tripType': '',
        'ccsqdRemark': '',
        'subjectCode': '',
        'ifSameOrder': ''
      }
      for(let k in obj){
        if(info[k]){
          obj[k]=info[k]
        }
      }
      this.travelInfo=obj
    },
    getLinker(info) {//修改联系人回调
      this.linker = {}
      this.linker = info
    },
  },
  watch: {
  }
}
</script>

<style lang="less" scoped>
.list{
    padding: 10px;
}
.box{
    padding-bottom: 5px;
}
.guestpasswrapper {
    height: calc(100vh - 96px);
    overflow: hidden;
}
</style>
